import { render, staticRenderFns } from "./QuestionCategoryCreate.vue?vue&type=template&id=fdc19b2c&scoped=true&"
import script from "./QuestionCategoryCreate.vue?vue&type=script&lang=js&"
export * from "./QuestionCategoryCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdc19b2c",
  null
  
)

export default component.exports